import axios from 'axios';

export async function fetchClassSubjects() {
  const url = 'https://cms.fainlearn.com/class-subjects?_sort=name:ASC';
  return axios({
    method: 'GET',
    url
  });
}

export async function fetchEduBoards() {
  const url = 'https://cms.fainlearn.com/education-boards?_sort=name:ASC';
  return axios({
    method: 'GET',
    url
  });
}

export async function getAllBannerAssets() {
  const url =
    'https://cms.fainlearn.com/upload/files?_sort=createdAt:DESC&_where[0][name_contains]=banner-assest';
  return axios({
    method: 'GET',
    url
  });
}

export async function getCollegeList(limit, startFrom) {
  // https://cms.fainlearn.com/college-lists?_limit=2&_sort=name:asc&_start=0
  const url = `https://cms.fainlearn.com/college-lists?_limit=${limit}&_sort=name:asc&_start=${startFrom}`;
  return axios({
    method: 'GET',
    url
  });
}

export async function getAllDiscoverStories() {
  const url = 'https://cms.fainlearn.com/Discovery-stories?_limit=-1&_sort=createdAt:ASC';
  return axios({
    method: 'GET',
    url
  });
}

export async function searchCollege(name, limit, startFrom) {
  // https://cms.fainlearn.com/college-lists?&name_contains=&_sort=name:asc
  const url = `https://cms.fainlearn.com/college-lists?name_contains=${name}&_sort=name:asc&_limit=${limit}&_start=${startFrom}`;
  return axios({
    method: 'GET',
    url
  });
}
